import React from 'react';
import PillTabs from '../ui/PillTabs';

export default function AuthModePill({ mode, onChange, disabled = false }) {
  return (
    <PillTabs
      value={mode}
      onChange={onChange}
      disabled={disabled}
      layoutId="auth-mode-pill"
      fullWidth
      className="mb-6 w-full"
      options={[
        { id: 'login', label: 'Sign in' },
        { id: 'signup', label: 'Sign up' },
      ]}
    />
  );
}
